import React from "react";
import { StoreTemplateSections } from "../components";

export const SectionsEditor = () => {
  return <StoreTemplateSections />;
};
